// GroupSubs: a list of group subscribers currently online.
// Show in the topic title bar
import React from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { GROUP_MEMBER_VIEW_TYPE } from '../tinode/constants'
import { profile } from '../stores/storages/ProfileStorage';
import Helpers from '../lib/helpers';

import { IconAddMember } from '../icons/svg'

const messages = defineMessages({
  prevent_add_member_security_group: {
    id: 'prevent_add_member_security_group',
    defaultMessage: 'This function has been disabled by admin',
    description: 'This function has been disabled by admin',
  },
})

class GroupSubs extends React.Component {
  constructor(props) {
    super(props);

    this.handleShowPopupAddMember = this.handleShowPopupAddMember.bind(this)
  }

  handleShowPopupAddMember() {
    const { formatMessage } = this.props.intl;
    const topicInfo = this.props.tinode.getTopicByName(this.props.topic);
    if (!topicInfo.isAdmin() && topicInfo?.public?.security === '1') {
      Helpers.showErrorToasts(formatMessage(messages.prevent_add_member_security_group))
    } else {
      this.props.handleShowGroupMembers({
        topicGroup: this.props.topic,
        groupView: GROUP_MEMBER_VIEW_TYPE.ADD_MEMBER,
        groupMembers: this.props.groupMembers,
      })
    }
  }

  render() {
    return (
      <div id="topic-users">
        <div className="icon-r tooltip-container" onClick={this.handleShowPopupAddMember}>
          <IconAddMember />
          <div className="tooltip tooltip-left">
            <FormattedMessage
              id="dialog_title_add_group_member"
              defaultMessage="Add Group Member"
            />
          </div>
        </div>
      </div>
    );
  }
};

export default injectIntl(GroupSubs);